import React from 'react';
import { Box, Tooltip } from '@material-ui/core';
import { useStyles } from '../styles/PracticasConvenio.styles';
import { normalizarEstadoPractica } from '../utils/formatters';

const BadgeEstado = ({ estado }) => {
  const classes = useStyles();
  
  const estadoNormalizado = normalizarEstadoPractica(estado);

  const getClassName = () => {
    switch (estadoNormalizado) {
      case 'aprobada':
        return classes.badgeAprobada;
      case 'pendiente':
        return classes.badgePendiente;
      case 'rechazada':
        return classes.badgeRechazada;
      case 'en_proceso':
        return classes.badgeEnProceso;
      case 'modificaciones':
        return classes.badgeModificaciones;
      case 'finalizada':
        return classes.badgeFinalizada;
      case 'archivada':
        return classes.badgeArchivada;
      default:
        return classes.badgeArchivada;
    }
  };

  return (
    <Tooltip title={estado || 'Sin estado'} arrow>
      <Box className={`${classes.badge} ${getClassName()}`}>
        <span>{estado || 'Sin estado'}</span>
      </Box>
    </Tooltip>
  );
};

export default BadgeEstado;
